import { Injectable } from "@angular/core";

@Injectable()
export class PagerService {

  totalItems: number;
  currentPage: number;
  pageSize: number;
  totalPages: number;
  startPage: number;
  endPage: number;
  startIndex: number;
  endIndex: number;
  pages: any[] = [];

  constructor() {}

  getPager(totalItems: number, currentPage = 1, pageSize = 10) {
    this.totalItems = totalItems;
    this.currentPage = currentPage;
    // calculate total pages
    this.totalPages = Math.ceil(totalItems / pageSize) ? Math.ceil(totalItems / pageSize) : 1;
    if(this.totalPages <= 10) {
      // less than 10 total pages so show all
      this.startPage = 1;
      this.endPage = this.totalPages;
    }
    else {
      // more than 10 total pages so calculate start and end pages
      if(currentPage <= 6) {
        this.startPage = 1;
        this.endPage = 10;
      }
      else if (currentPage + 4 >= this.totalPages) {
        this.startPage = this.totalPages - 9;
        this.endPage = this.totalPages;
      }
      else {
        this.startPage = currentPage - 5;
        this.endPage = currentPage + 4;
      }
    }
    // calculate start and end item indexes
    this.startIndex = (currentPage - 1) * pageSize;
    this.endIndex = Math.min(this.startIndex + pageSize - 1, totalItems - 1);
    // create an array of pages to ng-repeat in the pager control
    for(var a=this.startPage; a<this.endPage+1; a++) {
      this.pages.push(a);
    }
  }

}